exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* ANIMATION */\n/* SHADOWS */\n.OrderCoinsProcessed__container__2a2mC {\n  width: 8%;\n  float: left;\n  text-align: center; }\n\n.OrderCoinsProcessed__arrow__2tbr8 {\n  width: 32px;\n  margin-top: 37px;\n  fill: #9c9c9c; }\n", ""]);

// exports
exports.locals = {
	"container": "OrderCoinsProcessed__container__2a2mC",
	"arrow": "OrderCoinsProcessed__arrow__2tbr8"
};